// extracted by mini-css-extract-plugin
export var collage = "collageStyles-module__collage___FQDDN";
export var collageRow = "collageStyles-module__collageRow___OkLgF";
export var collageCol = "collageStyles-module__collageCol___ROQhT";
export var collageImage = "collageStyles-module__collageImage___qWAmZ";
export var leftCol = "collageStyles-module__leftCol___IyaL4";
export var rightCol = "collageStyles-module__rightCol___C6VNA";
export var wideImage = "collageStyles-module__wideImage___PDDIX";
export var wideImageSmall = "collageStyles-module__wideImageSmall___A31zi";
export var bottomRow = "collageStyles-module__bottomRow___eDbjv";